import isMobileBrowser from 'is-mobile'

import { faPlus } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import {
  Box, Button, Text,
} from '@domain-group/suit-theme'

import { CampaignModel, InvoiceModel } from '@models/types'

import useInvoiceItem from '@hooks/useInvoiceItem'

import Controls from './Controls'
import InvoiceItems from './InvoiceItems'

interface InvoiceInfoPanelProps {
  callbacks: {
    approveInvoice: () => void,
    deleteInvoice: () => void,
    showCreateOrEditInvoiceModal: (payload: { invoice: InvoiceModel }) => void,
  },
  campaign: CampaignModel,
  invoice: InvoiceModel,
  pdfDownloadUrl: string,
}

const InvoiceEditPanel = (props: InvoiceInfoPanelProps) => {
  const {
    callbacks,
    campaign,
    invoice,
    pdfDownloadUrl,
  } = props

  const { id, purchase_order, reference } = invoice

  const isMobile = isMobileBrowser()

  const { callbacks: { createOrEditInvoiceItem } } = useInvoiceItem({ invoice_id: invoice.id })

  return (
    <Box
      flexDirection="column"
      marginBottom="large"
      variant="white"
    >
      <Box
        borderBottom="1px solid"
        borderColor="lineColor"
        padding="large"
        flexDirection="row"
        marginBottom="medium"
      >
        <Box alignItems="center" flexDirection={['column', 'row']} justifyContent="space-between" maxWidth={isMobile && '50%'}>
          <Text fontSize="large" marginBottom="medium" minWidth="fit-content">Invoice #{id}</Text>

          <Box
            alignItems="flex-end"
            flexDirection="column"
            justifyContent="center"
            paddingRight="medium"
          >
            {reference && (
              <Text
                color="bodyFontLightColor"
                fontSize="small"
                marginBottom="small"
                textAlign="right"
                variant="ellipsis"
                maxWidth={isMobile && '100%'}
              >
                {reference}
              </Text>
            )}

            {purchase_order && (
              <Text
                color="bodyFontLightColor"
                fontSize="small"
                textAlign="right"
                variant="ellipsis"
              >
                {purchase_order}
              </Text>
            )}
          </Box>
        </Box>

        <Controls
          callbacks={callbacks}
          campaign={campaign}
          invoice={invoice}
          pdfDownloadUrl={pdfDownloadUrl}
        />
      </Box>

      <Box flexDirection="column">
        <InvoiceItems invoice={invoice} />

        <Box
          borderBottom="1px solid"
          borderColor="lineColor"
          justifyContent="flex-end"
          paddingBottom="large"
          paddingRight="large"
        >
          <Button
            buttonStyle="secondaryEdit"
            icon={<FontAwesomeIcon icon={faPlus} style={{ marginRight: '8px' }} />}
            onClick={createOrEditInvoiceItem}
            size="small"
            // @ts-expect-error TS2322
            variant="white"
            width="auto"
          >
            Add Line Item
          </Button>
        </Box>
      </Box>

      <Box
        flexDirection="row"
        justifyContent="flex-end"
        padding="large"
      >
        <Controls
          callbacks={callbacks}
          campaign={campaign}
          invoice={invoice}
          pdfDownloadUrl={pdfDownloadUrl}
        />
      </Box>
    </Box>
  )
}

export default InvoiceEditPanel
